import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorksSection() {
  const steps = [{
    num: '1',
    title: 'Configuras',
    desc: 'El entorno de sueño perfecto usando el checklist de oscuridad y ruido blanco.'
  }, {
    num: '2',
    title: 'Aplicas',
    desc: 'El Ritual de Desconexión Progresiva 30 minutos antes de dormir.'
  }, {
    num: '3',
    title: 'Utilizas',
    desc: 'La Pausa Consciente durante la noche para permitir que el bebé conecte sus ciclos de sueño de forma natural.'
  }];
  return <section className="bg-dark-200 text-text-dark py-20 md:py-28 px-6 relative overflow-hidden" data-id="element-70">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-71">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16 md:mb-24" data-id="element-72">
          <h2 className="text-3xl md:text-4xl font-serif mb-4" data-id="element-73">
            Cómo funciona
          </h2>
          <p className="text-accent text-lg" data-id="element-74">Un proceso simple de 3 pasos</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative" data-id="element-75">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-accent/20 z-0" data-id="element-76"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center space-y-6" data-id="element-77">
              <div className="w-24 h-24 rounded-full bg-dark-100 border-4 border-accent flex items-center justify-center shadow-[0_0_20px_rgba(212,165,116,0.2)]" data-id="element-78">
                <span className="text-4xl font-serif text-accent" data-id="element-79">
                  {step.num}
                </span>
              </div>
              <div data-id="element-80">
                <h3 className="text-2xl font-serif mb-3 text-white" data-id="element-81">
                  {step.title}
                </h3>
                <p className="text-text-dark/70 text-lg leading-relaxed" data-id="element-82">
                  {step.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}